export default __webpack_public_path__ + "static/media/radar-circle.5a2697d5.svg";